import {ApiResource} from 'common/util/model-resource/api-resource';
import {CustomProperty} from 'common/types/reports/query';

import {bulkDelete, bulkUpdate, customPropertyClient} from '../queries/app-api/custom-properties-client';

export class CustomPropertiesResource extends ApiResource<CustomProperty> {
  apiClient = customPropertyClient;

  async bulkDelete(customPropertyIds: number[]): ReturnType<typeof bulkDelete> {
    return bulkDelete(customPropertyIds);

    // TODO - updating the model is not needed for now since it's done manually where bulkDelete is used for now
    // customPropertyIds.forEach((customPropertyId) => {
    //   this.delete(customPropertyId);
    // });
  }

  async bulkPatch(customPropertyUpdates: Record<number, Partial<CustomProperty>>): ReturnType<typeof bulkUpdate> {
    const apiPayload = Object.entries(customPropertyUpdates).map(([customPropertyId, customPropUpdate]) => {
      return this.buildUpdatePayload(parseInt(customPropertyId), customPropUpdate);
    });
    return bulkUpdate(apiPayload);

    // TODO - updating the model is not needed for now since it's done manually where bulkDelete is used for now
    // this.update(customPropertyUpdates);
  }

  buildUpdatePayload(customPropertyId: number, customPropertyUpdate: Partial<CustomProperty>) {
    const customProp = this.getOne(customPropertyId).value;
    return {
      ...customProp,
      ...customPropertyUpdate,
    };
  }
}
